import React, { useState, useEffect, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import * as THREE from 'three';
import Scribble from '../../Utils/Scribble.js';
import SceneComponent from './SceneComponent';
import { ModelList } from "../../Utils/ModelsList.js"
import LayerControl from './LayerControl'; // Import LayerControl component
import Measurements from '../../clickTools/Measurements.js';
import Info from '../../clickTools/Info.js';
import ColorChange from '../../clickTools/ColorChange.js';
import ObjectDetails from '../../clickTools/ObjectDetails.js';
import { useProgress } from '@react-three/drei';
import InfoControl from './InfoControl.js';
import StopeStatistics from './StopeStatistics.js';
import ObjectDetailsPage from './ObjectDetailsPage.js';
import { SceneSlicer } from '../SceneSlicer/index.jsx';
import Slidethumbnail from './Slidethumbnail.js';
import BottomBarContainer from './BottomBarContainer.js';
import UnifiedPanel from './UnifiedPanel.js';
import { useClickStore } from '../../store/clickStore.js';
import { useShallow } from 'zustand/react/shallow';

const Presentation = ({ userEmail, onLogout }) => {

  const [three, setThree] = useState(null)
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  
  const { progress } = useProgress()

  const slicerPortal = useRef(null)

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isScribbleMode, setIsScribbleMode] = useState(false);
  const [selectedColor, setSelectedColor] = useState('black');
  const [previousSlideWasScene, setPreviousSlideWasScene] = useState(false);
  const [showDescription, setShowDescription] = useState(true); // Track description visibility

  // Automatically close sidebar on medium screens and below
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) { // Adjust the breakpoint as needed
        setIsSidebarOpen(false);
      }
    };

    // Initial check and add event listener
    handleResize();
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);




 // Define the slides, with some containing scene-specific content
 const slides = [
  { type: 'image', heading: 'EUREKA MINE', content: './presentation/eureka1.jpg' },
  //{ type: 'video', heading: 'Video Slide', content: './presentation/pp.mp4' },
  //{ type: 'youtube', heading: 'YouTube Slide', content: 'https://www.youtube.com/embed/ABS9ipi-LmU' },
  // {
  //   type: 'scene',
  //   heading: '3D Scene 1',
  //   content: {
  //     visibleObjects: ['EOM_Sep25', 'SouthDump'],
  //     cameraPosition: [5, 500, 5],
  //     lookAt: [0, 0, 0]
  //   }
  // }
  {
    type: 'scene',
    heading: 'Overview of Eureka',
    content: {
      visibleObjects: ['EOM_Sep25'],
      cameraPosition: [-2000, 0,100],
      lookAt: [0, -300, 0]
    }
  },{
    type: 'scene',
    heading: 'Historic RC',
    content: {
      visibleObjects: ['EOM_Sep25','Historic_RC'],
      cameraPosition: [-2000, 0,100],
      lookAt: [0, -300, 0]
    }
  },{
    type: 'scene',
    heading: 'Historic DD,RC',
    content: {
      visibleObjects: ['EOM_Sep25','Historic_DD','Historic_RC'],
      cameraPosition: [-2000, 0,100],
      lookAt: [0, -300, 0]
    }
  },{
    type: 'scene',
    heading: 'DGZ RC',
    content: {
      visibleObjects: ['EOM_Sep25','DGZ_RC'],
      cameraPosition: [-2000, 0,100],
      lookAt: [0, -300, 0]
    }
  },{
    type: 'scene',
    heading: 'Orebody',
    content: {
      visibleObjects: ['EOM_Sep25','Historic_DD','Historic_RC','DGZ_RC'
                      ,'molly','molly2','molly3','molly4','molly5'
                      ,'streaky','streaky2'
                      ,'zebra','zebra1','zebra2'
                    ],
      cameraPosition: [-2000, 0,100],
      lookAt: [0, -300, 0],
      description:' EU Pit - Current 100m deep , Design 260m deep (show arrow)  </br> Diamond Drilling - Drill holes DD , Drill holes RC (Old then new (Dallaglio) </br> EU Orebody - 1km strike ,Multiple narrow reefs ,Molly ,Zebra , Streaky '
    }
  },{
    type: 'scene',
    heading: 'Pushback',
    content: {
      visibleObjects: ['EOM_Sep25',
                      ,'molly','molly2','molly3','molly4','molly5'
                      ,'streaky','streaky2'
                      ,'zebra','zebra1','zebra2'
                      ,'PB1','PB2','PB3','PitDesign'
                    ],
      cameraPosition: [-2000, 0,100],
      lookAt: [0, -300, 0],
      description:' EU Pit - Current 100m deep , Design 260m deep (show arrow)  </br> Diamond Drilling - Drill holes DD , Drill holes RC (Old then new (Dallaglio) </br> EU Orebody - 1km strike ,Multiple narrow reefs ,Molly ,Zebra , Streaky '
    }
  }
  // ,{
  //   type: 'scene',
  //   heading: 'UG Workings',
  //   content: {
  //     visibleObjects: ['EOM_Sep25',
  //                     ,'molly','molly2','molly3','molly4','molly5'
  //                     ,'streaky','streaky2'
  //                     ,'zebra','zebra1','zebra2'
  //                     ,'PB1','PB2','PB3','PitDesign'
  //                     ,'UGDevelopmemt','UGStopes'
  //                   ],
  //                   cameraPosition: [-2000, 0,100],
  //                   lookAt: [0, -300, 0],
  //     description:' PLANNED UG DEVELOPMENT '
  //   }
  // }
  ,{
    type: 'scene',
    heading: 'UG Project',
    content: {
      visibleObjects: ['EOM_Sep25',
                      ,'PB5'
                      ,'EUG Plan DD','EUPit Plan DD1','EUPit Plan DD2','UG DECLINE'
                      ,'UGDevelopmemt','UGStopes'
                    ],
                    cameraPosition: [-195, 320,1918],
                    lookAt: [0, -300, 0],
      description:' PLANNED UG DEVELOPMENT '
    }
  },{
    type: 'scene',
    heading: 'BLASTS',
    content: {
      visibleObjects: ['EOM_Sep25','PB2',
                      'Jan2023','Feb2023','Mar2023','Apr2023','May2023','Jun2023','Sep2023',
                      'Apr2024','May2024','Jun2024'
                    ],
                    cameraPosition: [-500, 1500, 0],
                    lookAt: [0, 0, 0],
      description:' BLASTED BLOCKS'
    }
  }
];


  const handleSlideClick = (index) => {
    setPreviousSlideWasScene(slides[currentSlide].type === 'scene');
    setCurrentSlide(index);
    setIsScribbleMode(false); // Disable scribble mode on page change
    
    setShowDescription(true)
    


    const newVisibility = { ...layerVisibility };
    
    // Reset all layers to invisible
    Object.keys(newVisibility).forEach((key) => {
      newVisibility[key].visible = false;
    });

    // Enable only the layers specified in the slide's visibleObjects
    const visibleObjects = slides[index]?.content?.visibleObjects || [];
    visibleObjects.forEach((name) => {
      if (newVisibility[name]) {
        newVisibility[name].visible = true;
      }
    });

    setLayerVisibility(newVisibility);
  };

  const handleToggleScribbleMode = () => {
    setIsScribbleMode(!isScribbleMode);
  };

  const renderSlideContent = () => {
    const slide = slides[currentSlide];
    switch (slide.type) {
      case 'image':
        return <img src={slide.content} alt="Slide" className="w-full h-full object-cover" />;

      case 'video':
        return (
          <video controls className="max-w-full max-h-full mx-auto">
            <source src={slide.content} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );

      case 'youtube':
        return (
          <iframe
            width="100%"
            height="100%"
            src={slide.content}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="max-w-full max-h-full mx-auto"
          ></iframe>
        );

      case 'scene':
        return null; // We render the Canvas separately for scene slides

      default:
        return null;
    }
  };


  //////////LAYER VISIBILITY////////////////
  
  const [layerVisibility, setLayerVisibility] = useState({}); // Manage visibility of each layer
  const [showUnifiedPanel, setShowUnifiedPanel] = useState(false);
  const [activePanel, setActivePanel] = useState('layers'); // 'layers', 'information', 'statistics'
  const [panelWidth, setPanelWidth] = useState('default'); // 'default', '25', '50', '75', '100'
  // Remove local showMeasurements state - now using store
  const [isControlPanelCollapsed, setIsControlPanelCollapsed] = useState(true); // Toggle for Measurements visibility
  const [backgroundMode, setBackgroundMode] = useState(0); // 0: default gradient, 1: white, 2: black
  const [showGrid, setShowGrid] = useState(false);
  const [fogEnabled, setFogEnabled] = useState(false);

  // Fly-around state management
  const { isFlyAroundActive, setFlyAround, showMeasurements, setShowMeasurements, blockModelLegends, blockModelOpacity, setBlockModelOpacity, blockModelGradeRange, blockModelGradeFilter, setBlockModelGradeFilter, clickType, setSelectionRegion, pinnedInfos, removePinnedInfo, clearPinnedInfos } = useClickStore(
    useShallow((state) => ({
      isFlyAroundActive: state.isFlyAroundActive,
      setFlyAround: state.setFlyAround,
      showMeasurements: state.showMeasurements,
      setShowMeasurements: state.setShowMeasurements,
      blockModelLegends: state.blockModelLegends,
      blockModelOpacity: state.blockModelOpacity,
      setBlockModelOpacity: state.setBlockModelOpacity,
      blockModelGradeRange: state.blockModelGradeRange,
      blockModelGradeFilter: state.blockModelGradeFilter,
      setBlockModelGradeFilter: state.setBlockModelGradeFilter,
      clickType: state.clickType,
      setSelectionRegion: state.setSelectionRegion,
      pinnedInfos: state.pinnedInfos,
      removePinnedInfo: state.removePinnedInfo,
      clearPinnedInfos: state.clearPinnedInfos,
    }))
  );

  const legendGrades = Object.values(blockModelLegends || {}).filter(Boolean);
  const uniqueGrades = Array.from(new Set(legendGrades));
  const legendSuffix = uniqueGrades.length ? ` ${uniqueGrades.join(', ')}` : '';
  const showBlockModelLegend = uniqueGrades.length > 0;
  const blockModelLegendItems = [
    { color: '#ac02b4', label: `≥ 3${legendSuffix}` },
    { color: '#ff0000', label: `1.5 - 2.99${legendSuffix}` },
    { color: '#00ff00', label: `0.6 - 1.49${legendSuffix}` },
    { color: '#0000ff', label: `< 0.6${legendSuffix}` },
  ];

  // North arrow rotation state
  const [northArrowRotation, setNorthArrowRotation] = useState(0);

  // Log when showMeasurements changes
  useEffect(() => {
    // Track measurements visibility state
  }, [showMeasurements]);

  // Handle keyboard shortcut for toggling unified panel
  useEffect(() => {
    const handleToggleUnifiedPanel = () => {
      setShowUnifiedPanel(!showUnifiedPanel);
    };

    window.addEventListener('toggleUnifiedPanel', handleToggleUnifiedPanel);

    return () => {
      window.removeEventListener('toggleUnifiedPanel', handleToggleUnifiedPanel);
    };
  }, [showUnifiedPanel]);

  // Update north arrow rotation based on camera rotation
  useEffect(() => {
    if (!three || !three.camera) return;

    const updateNorthArrow = () => {
      const camera = three.camera;
      
      // Get camera's rotation around Y-axis (azimuth)
      // We need to calculate the angle between camera's forward direction and the positive Z-axis
      const cameraDirection = new THREE.Vector3();
      camera.getWorldDirection(cameraDirection);
      
      // Project the camera direction onto the XZ plane (ignore Y component)
      const horizontalDirection = new THREE.Vector3(cameraDirection.x, 0, cameraDirection.z).normalize();
      
      // Calculate angle between horizontal direction and positive Z-axis
      // Atan2 gives us the angle from Z+ axis to the camera direction
      const angle = Math.atan2(horizontalDirection.x, horizontalDirection.z);
      
      // Convert to degrees and handle quadrants properly
      let degrees = (angle * 180 / Math.PI);
      
      // Normalize to 0-360 range
      if (degrees < 0) {
        degrees += 360;
      }
      
      // For the north arrow, we want it to point in the opposite direction
      // of where the camera is looking, so we add 180 degrees
      degrees = (degrees + 180) % 360;
      
      setNorthArrowRotation(degrees);
    };

    // Update immediately
    updateNorthArrow();

    // Set up animation frame loop to continuously update
    const animationId = requestAnimationFrame(function animate() {
      updateNorthArrow();
      requestAnimationFrame(animate);
    });

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [three]);
  
  useEffect(() => {
    const initialVisibility = {};
    ModelList.forEach((group) => {
      group.models.forEach((model) => {
        initialVisibility[model.name] = { visible: false, url: model.url };
      });
    });
    setLayerVisibility(initialVisibility);
  }, []);

  // Apply background to CSS
  useEffect(() => {
    const root = document.documentElement;
    
    // Cycle through three background modes
    switch (backgroundMode) {
      case 0: // Default gradient
        root.style.setProperty('--gradient-bg', 'radial-gradient(#4a4a4a, #212121)');
        break;
      case 1: // White background
        root.style.setProperty('--gradient-bg', 'white');
        break;
      case 2: // Black background
        root.style.setProperty('--gradient-bg', 'black');
        break;
      default:
        root.style.setProperty('--gradient-bg', 'radial-gradient(#4a4a4a, #212121)');
    }
  }, [backgroundMode]);

   // Toggle visibility of layers from LayerControl
  const handleToggleVisibility = (modelName) => {
    setLayerVisibility((prevState) => ({
      ...prevState,
      [modelName]: {
        ...prevState[modelName],
        visible: !prevState[modelName].visible,
      }
    }));
  };

  // Get first initial of user email
  const getUserInitial = () => {
    if (!userEmail) return 'U';
    return userEmail.charAt(0).toUpperCase();
  };

  // Handle logout confirmation
  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const handleLogoutConfirm = () => {
    onLogout();
    setShowLogoutConfirm(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <div className="flex h-screen relative">
      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm mx-4 shadow-xl">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center mr-3">
                <span className="text-black font-bold text-lg">{getUserInitial()}</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Logout</h3>
                <p className="text-sm text-gray-600">Are you sure you want to logout?</p>
              </div>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={handleLogoutCancel}
                className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleLogoutConfirm}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Sidebar */}
      <div className={`transition-all duration-300 bg-black text-white h-full flex flex-col ${isSidebarOpen ? 'w-48' : 'w-12'}`}>
        {/* User Profile Button */}
        <div className="relative flex justify-center mb-2">
          <button
            onClick={handleLogoutClick}
            className="w-10 h-10 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black rounded-full shadow-lg hover:from-yellow-400 hover:to-yellow-500 focus:outline-none transition-all duration-200 font-bold text-lg flex items-center justify-center hover:scale-105"
            title={`Logged in as ${userEmail}`}
          >
            {getUserInitial()}
          </button>
        </div>
        
        <div className="relative flex justify-center mb-1">
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black p-1.5 rounded-full shadow-lg hover:from-yellow-400 hover:to-yellow-500 focus:outline-none transition-all duration-200 font-bold text-sm w-8 h-8 flex items-center justify-center"

          >
            {isSidebarOpen ? '←' : '→'}
          </button>
        </div>
        {isSidebarOpen ? (
          <div className='flex-1 overflow-y-auto p-1.5' >
            <h2 className="text-xs font-bold mb-2 text-center text-yellow-400 drop-shadow-lg tracking-wide">EUREKA</h2>
            <ul className="space-y-1">
              {slides.map((slide, index) => (
                <li
                key={index}
                className={`flex items-center p-1.5 cursor-pointer ${index === currentSlide ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-black' : 'bg-gray-700/80 hover:bg-gray-600/80'} transition-all rounded-md shadow-sm hover:shadow-md`}
                onClick={() => handleSlideClick(index)}
              >
                <div className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${index === currentSlide ? 'bg-yellow-300 text-black' : 'bg-gray-500 text-white'}`}>
                  {index + 1}
                </div>
                <span className="text-xs font-semibold ml-2 truncate">{slide.heading}</span>
              </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto">
            <ul className="flex flex-col items-center space-y-2 mt-8 px-1" >
              {slides.map((_, index) => (
                <li
                  key={index}
                  className={`w-6 h-6 flex items-center justify-center cursor-pointer rounded-full text-xs font-bold ${index === currentSlide ? 'bg-yellow-400 text-black shadow-lg' : 'bg-gray-500 text-white hover:bg-gray-400 shadow-sm'}`}
                  onClick={() => handleSlideClick(index)}
                >
                  {index + 1}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="flex-grow flex flex-col transition-all duration-300 relative overflow-auto">
      {(slides[currentSlide].type === 'scene' || slides[currentSlide].type === '360') && progress < 100 && (
          <div className="fixed inset-0 z-[1006] flex flex-col items-center justify-center bg-gray-900 bg-opacity-95 px-4 py-8">
            {/* Mining-themed loading animation */}
            <div className="relative w-full max-w-md flex flex-col items-center">
              {/* Rotating pickaxe */}
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center">
                <div className="text-4xl sm:text-6xl animate-spin" style={{ animationDuration: '2s' }}>
                  ⛏️
                </div>
              </div>
              
              {/* Gold nuggets falling */}
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
                <div className="text-lg sm:text-2xl animate-bounce" style={{ animationDelay: '0s', animationDuration: '1.5s' }}>
                  🪙
                </div>
              </div>
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
                <div className="text-lg sm:text-2xl animate-bounce" style={{ animationDelay: '0.5s', animationDuration: '1.5s' }}>
                  🪙
                </div>
              </div>
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
                <div className="text-lg sm:text-2xl animate-bounce" style={{ animationDelay: '1s', animationDuration: '1.5s' }}>
                  🪙
                </div>
              </div>
            </div>
            
            {/* Loading text with mining theme */}
            <div className="mt-6 sm:mt-8 text-center w-full max-w-lg">
              <h1 className="text-white text-xl sm:text-2xl font-bold mb-2">Mining Data...</h1>
              <p className="text-yellow-400 text-base sm:text-lg font-semibold">Extracting Gold Mining Information</p>
              
              {/* Bouncing loading bar */}
              <div className="mt-4 sm:mt-6 w-full max-w-xs sm:max-w-sm mx-auto bg-gray-700 rounded-full h-2 sm:h-3 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full animate-pulse"></div>
              </div>
              
              {/* Loading text */}
              <p className="text-yellow-300 text-base sm:text-lg font-bold mt-2">Loading...</p>
            </div>
          </div>
        )}
        <div className="flex-grow flex items-center justify-center bg-gray-400 overflow-hidden">
          {renderSlideContent()}
        </div>
        {/* Description Box */}
        {/* {showDescription && slides[currentSlide].content.description && (
          <div className="absolute bottom-14 left-0 w-full bg-gray-100 p-4 shadow-lg flex justify-between items-center text-gray-700 z-50">
            <p dangerouslySetInnerHTML={{ __html: slides[currentSlide].content.description }}></p>
            <button
              onClick={() => setShowDescription(false)}
              className="text-gray-500 hover:text-gray-700 font-bold text-sm w-fit"
            >
              &times;
            </button>
          </div>
        )} */}


        {slides[currentSlide].type === 'scene' && (
          <>

            {/* Compass Overlay */}
            <div className="absolute top-2 left-2 sm:top-4 sm:left-4 z-50">
              <div className="bg-white/80 border border-yellow-400 rounded-full w-12 h-12 sm:w-14 sm:h-14 shadow-lg flex items-center justify-center">
                <div className="relative w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-yellow-500/60">
                  <div className="absolute -top-1 left-1/2 -translate-x-1/2 text-[10px] font-semibold text-yellow-700">N</div>
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[10px] font-semibold text-yellow-700">S</div>
                  <div className="absolute left-0 top-1/2 -translate-y-1/2 text-[10px] font-semibold text-yellow-700">W</div>
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 text-[10px] font-semibold text-yellow-700">E</div>
                  <div
                    className="absolute left-1/2 top-1/2 w-0.5 h-4 sm:h-5 bg-red-500 origin-bottom"
                    style={{ transform: `translate(-50%, -100%) rotate(${northArrowRotation}deg)` }}
                  />
                  <div className="absolute left-1/2 top-1/2 w-1.5 h-1.5 bg-yellow-600 rounded-full -translate-x-1/2 -translate-y-1/2" />
                </div>
              </div>
            </div>

            {/* Top Right Control Panel */}
            <div className="absolute top-1 right-1 sm:top-2 sm:right-2 bg-white border border-yellow-400 rounded shadow z-50 overflow-hidden">
              {/* Collapsible Header */}
              <div className="flex items-center justify-center p-1 border-b border-gray-200">
                <button
                  onClick={() => setIsControlPanelCollapsed(!isControlPanelCollapsed)}
                  className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-yellow-500 hover:text-yellow-600 transition-all duration-200"
                  title={isControlPanelCollapsed ? "Expand Controls" : "Collapse Controls"}
                >
                  <span className={`text-xs transition-transform duration-200 ${isControlPanelCollapsed ? '' : 'rotate-180'}`}>
                    ▼
                  </span>
                </button>
              </div>
              
              {/* Control Buttons Container */}
              <div className={`transition-all duration-300 ease-in-out ${isControlPanelCollapsed ? 'max-h-0 opacity-0' : 'max-h-96 opacity-100'}`}>
                <div className="p-0.5 flex flex-col gap-0.5">
                  {/* Scribble Toggle Button */}
                  <button
                    onClick={handleToggleScribbleMode}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      isScribbleMode ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Toggle Scribble Mode"
                  >
                    <span className="text-xs">✏️</span>
                  </button>

                  {/* Background Control Button */}
                  <button
                    onClick={() => setBackgroundMode((prev) => (prev + 1) % 3)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      backgroundMode === 0 ? 'bg-gray-500 text-white' :
                      backgroundMode === 1 ? 'bg-white text-gray-800 border border-gray-300' :
                      'bg-black text-white'
                    }`}
                    title="Toggle Background"
                  >
                    <span className="text-xs">{backgroundMode === 0 ? '🌅' : backgroundMode === 1 ? '☀️' : '🌙'}</span>
                  </button>

                  {/* Fog Toggle */}
                  <button
                    onClick={() => setFogEnabled((prev) => !prev)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      fogEnabled ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Toggle Fog"
                  >
                    <span className="text-xs">🌫️</span>
                  </button>

                  {/* Grid Toggle */}
                  <button
                    onClick={() => setShowGrid((prev) => !prev)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      showGrid ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Toggle Grid"
                  >
                    <span className="text-xs">#</span>
                  </button>


                  {/* Unified Panel Button */}
                  <button
                    onClick={() => setShowUnifiedPanel(!showUnifiedPanel)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      showUnifiedPanel ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Panel Controls"
                  >
                    <span className="text-xs">📋</span>
                  </button>

                  {/* Measurements Button */}
                  <button
                    onClick={() => setShowMeasurements(!showMeasurements)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      showMeasurements ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Measurements Tools"
                  >
                    <span className="text-xs">🔧</span>
                  </button>

                  {/* Fly Around Button */}
                  <button
                    onClick={() => setFlyAround(!isFlyAroundActive)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      isFlyAroundActive ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Camera Fly Around"
                  >
                    <span className="text-xs">🎥</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Unified Panel */}
            {showUnifiedPanel && (
              <UnifiedPanel
                modelList={ModelList}
                layerVisibility={layerVisibility}
                onToggleVisibility={handleToggleVisibility}
                activePanel={activePanel}
                onPanelChange={setActivePanel}
                onClose={() => setShowUnifiedPanel(false)}
                panelWidth={panelWidth}
                onWidthChange={setPanelWidth}
              />
            )}

            {showBlockModelLegend && (
              <div className="fixed top-3 left-1/2 -translate-x-1/2 z-10">
                <div className="bg-black/30 text-white text-xs px-2.5 py-1.5 rounded-md flex items-center gap-3">
                  <div className="flex items-center gap-2 pr-2 border-r border-white/30">
                    <span className="text-[10px] uppercase tracking-wide">Grade</span>
                    <input
                      type="number"
                      step="0.01"
                      value={blockModelGradeFilter?.min ?? blockModelGradeRange?.min ?? ''}
                      onChange={(e) =>
                        setBlockModelGradeFilter({
                          min: e.target.value === '' ? null : Number(e.target.value),
                          max: blockModelGradeFilter?.max ?? blockModelGradeRange?.max ?? null,
                        })
                      }
                      className="w-16 bg-black/30 text-white text-[10px] px-1.5 py-0.5 rounded border border-white/20"
                      aria-label="Minimum grade"
                    />
                    <input
                      type="number"
                      step="0.01"
                      value={blockModelGradeFilter?.max ?? blockModelGradeRange?.max ?? ''}
                      onChange={(e) =>
                        setBlockModelGradeFilter({
                          min: blockModelGradeFilter?.min ?? blockModelGradeRange?.min ?? null,
                          max: e.target.value === '' ? null : Number(e.target.value),
                        })
                      }
                      className="w-16 bg-black/30 text-white text-[10px] px-1.5 py-0.5 rounded border border-white/20"
                      aria-label="Maximum grade"
                    />
                  </div>
                  {blockModelLegendItems.map((item) => (
                    <div key={item.label} className="flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full" style={{ background: item.color }} />
                      <span>{item.label}</span>
                    </div>
                  ))}
                  <div className="flex items-center gap-2 pl-2 border-l border-white/30">
                    <span className="text-[10px] uppercase tracking-wide">Opacity</span>
                    <input
                      type="range"
                      min="0.1"
                      max="1"
                      step="0.05"
                      value={blockModelOpacity}
                      onChange={(e) => setBlockModelOpacity(Number(e.target.value))}
                      className="w-20 accent-yellow-400"
                      aria-label="Block model opacity"
                    />
                  </div>
                </div>
              </div>
            )}

            <SelectionOverlay
              enabled={clickType === 'box' || clickType === 'lasso'}
              mode={clickType}
              onComplete={setSelectionRegion}
            />

            {pinnedInfos.length > 0 && (
              <div className="absolute top-20 right-2 sm:top-24 sm:right-3 z-50 w-56">
                <div className="bg-white/90 border border-yellow-400 rounded shadow p-2">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-semibold text-gray-700">Pinned Info</span>
                    <button
                      onClick={clearPinnedInfos}
                      className="text-[10px] text-red-600 hover:text-red-700"
                      title="Clear All"
                    >
                      Clear
                    </button>
                  </div>
                  <div className="space-y-1 max-h-48 overflow-auto">
                    {pinnedInfos.map((item) => (
                      <div key={item.id} className="bg-white rounded border border-gray-200 p-1">
                        <div className="flex items-center justify-between">
                          <span className="text-[10px] font-semibold text-gray-700">{item.name}</span>
                          <button
                            onClick={() => removePinnedInfo(item.id)}
                            className="text-[10px] text-gray-500 hover:text-gray-700"
                            title="Remove"
                          >
                            ✕
                          </button>
                        </div>
                        <div className="text-[10px] text-gray-600">
                          {item.summary}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

       
            <Canvas className="absolute inset-0" flat shadows gl={{ antialias: true }} camera={{ position: [0, 7000, 0], near: 0.5, far: 10000, fov: 35 }}>
              <SceneComponent
                currentSlide = {currentSlide}
                layerVisibility={layerVisibility} 
                cameraPosition={slides[currentSlide].content.cameraPosition}
                lookAt={slides[currentSlide].content.lookAt}
                animateCamera={previousSlideWasScene}
                onThreeReady={setThree}
                showGrid={showGrid}
                fogEnabled={fogEnabled}
              />
            </Canvas>
            {/* Add the slicer component */}
            {three && <SceneSlicer three={three} />}

            {/* <BottomBarContainer showUnifiedPanel={showUnifiedPanel} panelWidth={panelWidth}/> */}
            <Measurements showMeasurements={showMeasurements} />
            <ColorChange/>
            <ObjectDetails/>
            <Info/>
          </>



        )}


        {/* Scribble Component */}
        <Scribble
          isScribbleMode={isScribbleMode}
          selectedColor={selectedColor}
          onColorChange={setSelectedColor}
        />

        

        {/* Footer Navigation */}
        {/* <div className="py-1 bg-blue-200 text-blue-900 flex justify-between items-center px-4">
          <button
            onClick={() => handleSlideClick((currentSlide - 1 + slides.length) % slides.length)}
            className="bg-blue-600 text-white w-fit px-3 py-1 md:px-4 md:py-2 rounded shadow-md hover:bg-blue-700"
          >
            Previous
          </button>
          <span className="text-center text-sm md:text-lg w-fit">
            <div className="w-fit p-2 h-5  md:h-12 flex items-center justify-center rounded-full shadow bg-gray-100 font-bold">
              {currentSlide + 1} / {slides.length}
            </div>
          </span>
          <button
            onClick={() => handleSlideClick((currentSlide + 1) % slides.length)}
            className="bg-blue-600 text-white w-fit px-3 py-1 md:px-4 md:py-2 rounded shadow-md hover:bg-blue-700"
          >
            Next
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Presentation;

const SelectionOverlay = ({ enabled, mode, onComplete }) => {
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startPoint, setStartPoint] = useState(null);
  const [currentPoint, setCurrentPoint] = useState(null);
  const [lassoPoints, setLassoPoints] = useState([]);

  if (!enabled) {
    return null;
  }

  const getLocalPoint = (event) => {
    const rect = containerRef.current.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    };
  };

  const handlePointerDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const point = getLocalPoint(event);
    setIsDragging(true);
    setStartPoint(point);
    setCurrentPoint(point);
    if (mode === 'lasso') {
      setLassoPoints([point]);
    }
  };

  const handlePointerMove = (event) => {
    if (!isDragging) return;
    event.preventDefault();
    event.stopPropagation();
    const point = getLocalPoint(event);
    setCurrentPoint(point);
    if (mode === 'lasso') {
      const last = lassoPoints[lassoPoints.length - 1];
      if (!last || Math.hypot(point.x - last.x, point.y - last.y) > 6) {
        setLassoPoints((prev) => [...prev, point]);
      }
    }
  };

  const finishSelection = () => {
    if (!startPoint || !currentPoint) return;
    const payload =
      mode === 'box'
        ? {
            type: 'box',
            rect: { x1: startPoint.x, y1: startPoint.y, x2: currentPoint.x, y2: currentPoint.y },
          }
        : {
            type: 'lasso',
            points: lassoPoints.length > 2 ? lassoPoints : [startPoint, currentPoint],
          };
    onComplete({ ...payload, phase: 'complete', id: Date.now() });
  };

  const handlePointerUp = (event) => {
    event.preventDefault();
    event.stopPropagation();
    finishSelection();
    setIsDragging(false);
  };

  const handlePointerLeave = () => {
    if (!isDragging) return;
    finishSelection();
    setIsDragging(false);
  };

  const rectLeft = startPoint && currentPoint ? Math.min(startPoint.x, currentPoint.x) : 0;
  const rectTop = startPoint && currentPoint ? Math.min(startPoint.y, currentPoint.y) : 0;
  const rectWidth = startPoint && currentPoint ? Math.abs(currentPoint.x - startPoint.x) : 0;
  const rectHeight = startPoint && currentPoint ? Math.abs(currentPoint.y - startPoint.y) : 0;

  const lassoPath =
    lassoPoints.length > 1
      ? `M ${lassoPoints.map((p) => `${p.x} ${p.y}`).join(' L ')}`
      : '';

  return (
    <div
      ref={containerRef}
      className="absolute inset-0 z-40"
      style={{ cursor: 'crosshair' }}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerLeave={handlePointerLeave}
    >
      {mode === 'box' && isDragging && (
        <div
          className="absolute border border-yellow-400 bg-yellow-200/10"
          style={{
            left: `${rectLeft}px`,
            top: `${rectTop}px`,
            width: `${rectWidth}px`,
            height: `${rectHeight}px`,
          }}
        />
      )}
      {mode === 'lasso' && isDragging && lassoPath && (
        <svg className="absolute inset-0" width="100%" height="100%">
          <path d={lassoPath} fill="none" stroke="#facc15" strokeWidth="1.5" />
        </svg>
      )}
    </div>
  );
};
